import * as React from 'react';

import { first } from 'lodash';

import { useNativeData, useNativeDataContext } from 'bundles/ent-website/components/NativeDataContext';
import type { ProductPrice } from 'bundles/ent-website/types';
import { useNaptime } from 'bundles/naptimejs';
import EnterpriseSelfServeContractProductPrices from 'bundles/naptimejs/resources/enterpriseSelfServeContractProductPrices.v1';

// TODO: This is a temporary solution to get the price to display correctly.
// We should consider locale as in the <ReactPriceDisplay /> component.
function prettifyPrice(price: string) {
  const numericPrice = Number(price);
  const prettyPrice = numericPrice % 1 === 0 ? numericPrice.toFixed(0) : numericPrice.toFixed(2);
  return prettyPrice;
}

function TeamsUnitPriceDataSource() {
  const { setNativeData } = useNativeDataContext();
  const nativeData = useNativeData('promo');

  const naptimeResponse = useNaptime<{ productPrice: ProductPrice[] }>(() => {
    return {
      productPrice: EnterpriseSelfServeContractProductPrices.getEnterpriseSelfServeContractProductPrice({
        userLimit: 1,
        billingType: 1,
        termInstallmentsTotal: 1,
        enterprisePromotionId: nativeData?.enterprisePromotion?.id,
        userIdOpt: 0,
      }),
    };
  }, [nativeData?.enterprisePromotion?.id]);

  const {
    data: { productPrice },
  } = naptimeResponse;

  const unitPrice = first(productPrice)?.actualLocalAmountTotal;
  const currencyCode = first(productPrice)?.currencyCode || 'USD';

  React.useEffect(() => {
    if (!nativeData) return;

    setNativeData('teamsUnitPrice', {
      unitPrice,
      currencyCode,
      prettyPrice: unitPrice ? prettifyPrice(unitPrice) : undefined,
    });
  }, [setNativeData, unitPrice, currencyCode, nativeData]);

  return null;
}

export default TeamsUnitPriceDataSource;
